import React from 'react'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Container from '@mui/material/Container'
import Drawer from '@mui/material/Drawer'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import useMediaQuery from '@mui/material/useMediaQuery'

import ConsultationIcon from '@/components/ui/icons/Consultation'

import ConsultationsSearchForm from './containers/ConsultationsSearchForm'
import ConsultationsTable from './containers/ConsultationsTable'
import StartLocalConsultationDialog from '@/pages/home/containers/StartLocalConsultationDialog'

type ConsultationsPageProps = {}

const sidebarWidth = 300

export default function LocalConsultationsPage(props: ConsultationsPageProps) {
  const theme = useTheme()
  const { t } = useTranslation()
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'), { noSsr: true })
  const [openCreateLocalConsultationDialog, setOpenCreateLocalConsultationDialog] = React.useState(false)
  return (
    <Box>
      {isLargeScreen && (
        <Drawer
          variant="permanent"
          sx={{
            width: sidebarWidth,
            flexShrink: 0,
            [`& .MuiDrawer-paper`]: {
              width: sidebarWidth,
              boxSizing: 'border-box',
              pb: '20px',
              [theme.breakpoints.up('md')]: {
                position: 'absolute',
              },
            },
          }}
        >
          <Toolbar />
          <ConsultationsSearchForm />
        </Drawer>
      )}
      <Box sx={[isLargeScreen && { marginLeft: `${sidebarWidth}px` }]}>
        <Container maxWidth="lg">
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography variant="h2" sx={{ mt: '30px', mb: '30px' }}>
              {t('page.localConsultations.title')}
            </Typography>
            <Button data-testid="create-local-consultation-button" onClick={() => setOpenCreateLocalConsultationDialog(true)} variant="contained" startIcon={<ConsultationIcon htmlColor="#FFF" />}>
              {t('page.localConsultations.createConsultationButton.label')}
            </Button>
          </Stack>
          {!isLargeScreen && (
            <Paper sx={{ mb: '20px', pt: '1px', pb: '15px' }}>
              <ConsultationsSearchForm direction="row" />
            </Paper>
          )}
          <ConsultationsTable />
        </Container>
        {openCreateLocalConsultationDialog && (
          <StartLocalConsultationDialog open={openCreateLocalConsultationDialog} onClose={() => setOpenCreateLocalConsultationDialog(false)} />
        )}
      </Box>
    </Box>
  )
}
